import { render, staticRenderFns } from "./select-area.vue?vue&type=template&id=30446875&scoped=true&"
import script from "./select-area.vue?vue&type=script&lang=js&"
export * from "./select-area.vue?vue&type=script&lang=js&"
import style0 from "./select-area.vue?vue&type=style&index=0&id=30446875&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30446875",
  null
  
)

export default component.exports